/* ------------------------------------------------------------------
   NOBL product-page extras — behavior
   Ported from the nobeltravel theme: product tabs switching and the
   product reels (story-style) modal player.
------------------------------------------------------------------ */

document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-nobl-tab]');
  if (!btn) return;

  var root = btn.closest('[data-nobl-tabs]');
  if (!root) return;

  var key = btn.dataset.noblTab;

  root.querySelectorAll('[data-nobl-tab]').forEach(function (x) {
    var active = x === btn;
    x.classList.toggle('is-active', active);
    x.setAttribute('aria-selected', active ? 'true' : 'false');
  });

  root.querySelectorAll('[data-nobl-panel]').forEach(function (x) {
    x.classList.toggle('is-active', x.dataset.noblPanel === key);
  });
});

(function () {
  function closeNoblReel(modal) {
    if (!modal) return;

    var media = modal.querySelector('[data-nobl-reel-media]');
    if (media) {
      media.querySelectorAll('video').forEach(function (v) {
        try { v.pause(); } catch (e) {}
      });
      media.innerHTML = '';
    }

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nobl-reel-open');

    var opener = modal._noblOpener;
    if (opener && typeof opener.focus === 'function') opener.focus();
    modal._noblOpener = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-nobl-reel-open]');
    if (opener) {
      var root = opener.closest('[data-nobl-product-reels]');
      var modal = root && root.querySelector('[data-nobl-reel-modal]');
      var media = modal && modal.querySelector('[data-nobl-reel-media]');
      var preview = opener.querySelector('video');
      if (!modal || !media || !preview) return;

      var player = preview.cloneNode(true);
      player.removeAttribute('autoplay');
      player.controls = true;
      player.muted = false;
      player.loop = false;
      player.playsInline = true;
      player.className = 'nobl-reel-modal__video';
      try { player.currentTime = 0; } catch (err) {}

      media.innerHTML = '';
      media.appendChild(player);
      modal._noblOpener = opener;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nobl-reel-open');

      var close = modal.querySelector('.nobl-reel-modal__close');
      if (close) close.focus({ preventScroll: true });

      var playPromise = player.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          player.muted = true;
          player.play().catch(function () {});
        });
      }
      return;
    }

    var closer = e.target.closest('[data-nobl-reel-close]');
    if (closer) {
      closeNoblReel(closer.closest('[data-nobl-reel-modal]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var modal = document.querySelector('[data-nobl-reel-modal]:not([hidden])');
    if (modal) closeNoblReel(modal);
  });
})();
